const PAGE_RE = /^.*\?(?:.*&)?p=(\d+).*$/;
const getPageNumberFromUrl = function(url) {
    if (PAGE_RE.test(url)) {
    return url.replace(PAGE_RE, "$1");
    } else { return 1; }
};

class RequestPattern {

    constructor(verb, patt, builder, postprocessor) {
        this.verb = verb;
        this.builder = builder;
        this.postprocessor = postprocessor != null ? postprocessor : (it, config) => it;
        let re = this.verb + " ";
        this.replace = "";
        this.names = [];
        let start = 0;
        while (true) {
            const open = patt.indexOf("{", start);
            const close = patt.indexOf("}", open);
            if ((open >= 0) && (close > open)) {
                const lit = patt.substring(start, open);
                re += lit;
                this.replace += lit;
                const parts = patt.substring(open + 1, close).split(":");
                this.names.push(parts[0]);
                if (parts.length === 1) { parts.push("s"); }
                re += "(";
                if (parts[1] === "s") {
                    re += "[a-zA-Z0-9_-]+";
                } else if (parts[1] === "i") {
                    re += "[0-9]+";
                } else {
                    throw new Error(`Unrecognized pattern expression interpolation type: '${parts[1]}'`);
                }
                re += ")";
                this.replace += "$" + this.names.length;
                start = close + 1;
            } else {
                const lit = patt.substring(start);
                re += lit;
                this.replace += lit;
                break;
            }
        }

        if (re.indexOf(".") < 0) {
            re += "(\\.json)?";
            this.replace += ".json";
        }
        this.regexp = new RegExp(`^${re}$`);
    }

    extension(ext) {
        const prev = this.postprocessor;
        return this.postprocessor = function(url, config) {
            const parts = prev(url, config).split(".");
            parts.pop();
            parts.push(ext);
            return parts.join(".");
        };
    }

    suffixed(suffix) {
        const prev = this.postprocessor;
        this.postprocessor = function(url, config) {
            url = prev(url, config);
            return url.replace(/^(.*)\.([^.]+)$/, `$1.${suffix}.$2`);
        };
        return this;
    }

    paged() {
        const prev = this.postprocessor;
        this.postprocessor = function(url, config) {
            url = prev(url, config);
            return url.replace(/^(.*)\.([^.]+)$/, `$1.p.${getPageNumberFromUrl(config.url)}.$2`);
        };
        return this;
    }

    postprocess(callback) {
        const prev = this.postprocessor;
        this.postprocessor = function(url, config) {
            url = prev(url, config);
            return callback(url, config);
        };
        return this;
    }

    filtered(f) {
        this.filter = f;
        return this;
    }

    hasDataFilter() {
        return (this.filter != null);
    }

    getDataFilter(req, config) {
        return (data, type) => {
            if (type === "json") {
                return JSON.stringify(this.filter(JSON.parse(data), req, config));
            } else {
                return this.filter(data, req, config);
            }
        };
    }

    test(req) {
        return this.regexp.test(req);
    }

    build(req, config) {
        return this.postprocessor(((this.builder != null)
        ? this.builder(this.getParts(req), config)
        : req.replace(this.regexp, this.replace)), config);
    }

    getParts(req) {
        const matches = this.regexp.exec(req);
        matches.shift(); // remove the overall match
        const parts = {};
        for (const n of this.names) {
            parts[n] = matches.shift();
        }
        return parts;
    }
}

export default RequestPattern;



// WEBPACK FOOTER //
// ./test/mock/lib/RequestPattern.js